export default __webpack_public_path__ + "static/media/project-no-photo.bf4f2af1.svg";